import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const pageTitles: Record<string, string> = {
  '/': 'Bank Sheets - Login',
  '/dashboard': 'Bank Sheets - Dashboard',
  '/settings': 'Bank Sheets - Settings',
  '/sheets': 'Bank Sheets - Sheets',
  '/success': 'Bank Sheets - Success',
  '/cancel': 'Bank Sheets - Cancelled',
  '/cancel-successful': 'Bank Sheets - Account Cancelled',
}

export const PageTitle = () => {
  const location = useLocation()

  useEffect(() => {
    const title = pageTitles[location.pathname] || 'Bank Sheets'
    document.title = title
  }, [location])

  return null
}
